<template>
  <div>
    <report-header @generate="load" @filterChanged="filterChanged"
      @onChangedDateStart="onChangedDateStart" @onChangedDateEnd="onChangedDateEnd" @onChangedTypeUsers="onChangedTypeUsers"
      :filterOptions="filterOptions" :isGenerateDisabled="isGenerateDisabled" @paginationChanged="paginationChanged"
      @limitChanged="limitChanged"
      @download="download"/>

    <basic-table
      @Filtred="Filtred"
      :items="userChangeLog"
      :fields="userChangeLogFields"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
  </div>
</template>

<script>
import download from '@/utils/downloadFile'
export default {
  props: {
    userId: 0
  },
  data () {
    return {
      isGenerateDisabled: false,
      selectTypeUsers: 0,
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      dateStart: this.$root.setDataWithSelectedTZ().toDate(),
      dateEnd: this.$root.setDataWithSelectedTZ().toDate(),
      filterOptions: {
        isFilterGroup: false,
        isFilterTypeTraffic: false,
        isFilterTypeDocuments: false,
        isFilterTypeUsers: true,
        isFilterCollector: false,
        isDownloadable: true,
        hasLimitRows: true
      },
      getStore: {
        numDateEnd: 0,
        numDateStart: 0,
        userId: 0,
        selectTypeUsers: 0,
        limit: 500,
        download: 0
      },
      userChangeLog: [],
      userChangeLogFields: [
        {key: 'user_id', label: this.$i18n.t('User ID'), sortable: true},
        {key: 'login', label: this.$i18n.t('Login'), sortable: true},
        {key: 'who', label: this.$i18n.t('Who'), sortable: true},
        {key: 'date', label: this.$i18n.t('Time'), sortable: true, formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'what', label: this.$i18n.t('What'), sortable: true},
        {key: 'comment', label: this.$i18n.t('Comment'), sortable: true},
        {key: 'Action', label: this.$i18n.t('Action'), sortable: true}
      ]
    }
  },
  methods: {
    Filtred (items) {
      this.totalRows = items.length
    },
    async load (isGenerateClick = true) {
      this.isGenerateDisabled = true
      let numDateEnd = Number(this.dateEnd) / 1000
      if (numDateEnd > 2147483647) numDateEnd = 2147483647
      let numDateStart = Number(this.dateStart) / 1000
      if (numDateStart > 2147483647) numDateStart = 2147483647
      this.getStore.numDateEnd = numDateEnd
      this.getStore.numDateStart = numDateStart
      this.getStore.selectTypeUsers = this.selectTypeUsers
      if (this.userId) {
        this.getStore.userId = this.userId
      }
      await this.$store.dispatch('Reports/GET_CHANGE_LOG', this.getStore).then(response => {
        if (isGenerateClick) {
          this.userChangeLog = this.$store.getters['Reports/CHANGE_LOG']
        } else {
          download(this.$store.getters['Reports/CHANGE_LOG'], 'report_others_change_log.csv', 'text/csv')
        }

        for (let el of this.userChangeLog) {
          if (el.staff_id === 0) {
            el.who = this.$i18n.t('Systema') + ' (' + el.staff_id + ')'
          } else if (el.staff_id < 0) {
            for (let elSystemUsers of this.systemUsers) {
              if (el.staff_id === elSystemUsers.user_id) {
                el.who = elSystemUsers.login + ' (' + el.staff_id + ')'
                break
              }
            }
          } else {
            for (let elUsers of this.allUsers) {
              if (el.staff_id === elUsers.user_id) {
                el.who = elUsers.login + ' (' + el.staff_id + ')'
                break
              }
            }
          }

          switch (el.action) {
            case 1:
              el.Action = this.$i18n.t('Correction of invoice positions')
              break
            case 2:
              el.Action = this.$i18n.t('Balance correction')
              break
            case 3:
              el.Action = this.$i18n.t('Adding user')
              break
            case 4:
              el.Action = this.$i18n.t('Editing user')
              break
            case 5:
              el.Action = this.$i18n.t('Deleting user')
              break
            case 6:
              el.Action = this.$i18n.t('Adding IP Group')
              break
            case 7:
              el.Action = this.$i18n.t('Editing IP group')
              break
            case 8:
              el.Action = this.$i18n.t('Adding user group')
              break
            case 9:
              el.Action = this.$i18n.t('Deleting user group')
              break
            case 10:
              el.Action = this.$i18n.t('Editing user group')
              break
            case 11:
              el.Action = this.$i18n.t('Adding user to group')
              break
            case 12:
              el.Action = this.$i18n.t('Removing user from group')
              break
            case 13:
              el.Action = this.$i18n.t('Adding account')
              break
            case 14:
              el.Action = this.$i18n.t('Editing account')
              break
            case 15:
              el.Action = this.$i18n.t('Adding service')
              break
            case 16:
              el.Action = this.$i18n.t('Editing service')
              break
            case 17:
              el.Action = this.$i18n.t('Users group operations')
              break
            case 18:
              el.Action = this.$i18n.t('Adding tariff')
              break
            case 19:
              el.Action = this.$i18n.t('Editing tariff')
              break
            case 20:
              el.Action = this.$i18n.t('Deleting tariff')
              break
            case 21:
              el.Action = this.$i18n.t('Adding service to tariff')
              break
            case 22:
              el.Action = this.$i18n.t('Deleting service from tariff')
              break
            case 23:
              el.Action = this.$i18n.t('Unlinking tariff from account')
              break
            case 24:
              el.Action = this.$i18n.t('Linking tariff to account')
              break
            case 25:
              el.Action = this.$i18n.t('Adding additional settings parameter')
              break
            case 26:
              el.Action = this.$i18n.t('Editing additional settings parameter')
              break
            case 27:
              el.Action = this.$i18n.t('Deleting additional settings parameter')
              break
            case 28:
              el.Action = this.$i18n.t('Instant tariff change')
              break
            case 29:
              el.Action = this.$i18n.t('Policy change')
              break
            case 30:
              el.Action = this.$i18n.t('Additing technical parameter')
              break
            case 31:
              el.Action = this.$i18n.t('Editing technical parameter')
              break
            case 32:
              el.Action = this.$i18n.t('Deleting technical parameter')
              break
            case 33:
              el.Action = this.$i18n.t('Settings voluntary blocking')
              break
            case 34:
              el.Action = this.$i18n.t('Delete voluntary blocking')
              break
            case 35:
              el.Action = this.$i18n.t('Add service link')
              break
            case 36:
              el.Action = this.$i18n.t('Delete service link')
              break
            case 37:
              el.Action = this.$i18n.t('Cost coefficient change')
              break
          }
        }
      })
      this.loadDone()
    },
    download () {
      this.getStore.download = 1
      this.load(false)
      this.$store.dispatch('Reports/CLEAR_CHANGE_LOG')
      this.getStore.download = 0
      this.totalRows = 0
      this.userChangeLog = []
    },
    limitChanged (limit) {
      this.getStore.limit = limit
    },
    onChangedDateStart (value) {
      this.dateStart = value
    },
    onChangedDateEnd (value) {
      this.dateEnd = value
    },
    onChangedTypeUsers (value) {
      this.selectTypeUsers = (value)
    },
    filterChanged (value) {
      this.filter = value
    },
    loadDone () {
      this.isGenerateDisabled = false
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  mounted () {
    this.$store.dispatch('Users/GET_SYSTEM_USERS_SHORT_DATA')
    this.$store.dispatch('Users/GET_ALL_USERS')
    this.loadDone()
    if (this.userId) {
      this.filterOptions.isFilterGroup = false
      this.filterOptions.isFilterAccsGroup = false
    }
  },
  computed: {
    systemUsers () {
      return this.$store.getters['Users/SYSTEM_USERS_SHORT_DATA']
    },
    allUsers () {
      return this.$store.getters['Users/ALL_USERS']
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/reports/other/changeLog/main.vue